<script lang="ts">
    let className: string = "";
    export { className as class };
    export let style: string = "";
</script>

<svg
    {style}
    class={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ><g fill="none" fill-rule="evenodd"
        ><path d="M0 0h24v24H0z"></path><circle
            fill="#335EEA"
            opacity=".3"
            cx="12"
            cy="12"
            r="10"
        ></circle><rect fill="#335EEA" x="11" y="10" width="2" height="7" rx="1"
        ></rect><rect fill="#335EEA" x="11" y="7" width="2" height="2" rx="1"
        ></rect></g
    ></svg
>
